<template>
<div class="pageForm__content storyTrial u-mg-b-2"
  :data-free="isFree"
  :data-loading="isLoading"
>
  <div class="card__backdrop"></div>
  <app-loading class="card__loading" :is-loading="isLoading"></app-loading>
  <div class="pageForm__menu-title u-mg-2" v-if="!hasTrialResult">
    <span>生年月日を入力してください</span>
  </div>
  <div class="pageForm__area">
    <div class="loadingArea" v-show="!loadingData && isLoggedIn">
      <div class="loadingArea__content">
        <app-loading :is-loading="true"></app-loading>
      </div>
    </div>

    <div ref="resultArea" class="trial__result u-mg-1" v-show="hasTrialResult">
      <!-- <h4 class="u-tx-center u-tx-brand">{{ displayNickname }}さんの結果は…</h4> -->
      <div v-for="result in results.result_data" :key="result.title" class="resultContent">
        <p class="u-mg-0" v-if="result.text1" v-html="result.text1"></p>
        <p class="u-mg-0" v-if="result.text2" v-html="result.text2"></p>
        <p class="u-mg-0" v-if="result.text3" v-html="result.text3"></p>
      </div>
      <share-buttons v-if="false"></share-buttons>
    </div>

    <div :class="{'dashed_border u-pd-1':hasTrialResult}">
      <div :class="{'accordion':hasTrialResult, 'show':isShow}">
        <div class="card-simple__button" v-if="hasTrialResult" @click="showInputArea">
          <p class="u-mg-1">プロフィールを変えてもう一度占う</p>
        </div>

        <div :class="{'u-mg-2':!hasTrialResult, 'u-mg-1 u-mg-b-4':hasTrialResult}">
          <form
          ref="form"
          scope="trialForm"
          @submit="handleSubmit"
          >
          <div
          class="alert"
          data-color="error"
          v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <div v-for="(field, key) in self" :key="key">
          <story-trial-input
          v-model="self[key].value"
          :name="key" :field="field"
          @input="updateInput(key, field)"
          @change="updateInput(key, field)"
          ></story-trial-input>
        </div>

        <div v-for="(field, key) in target" :key="key">
          <story-trial-input
          v-model="target[key].value"
          :name="key" :field="field"
          @input="updateInput(key, field)"
          @change="updateInput(key, field)"
          ></story-trial-input>
        </div>
      </form>
      <div class="submitarea">
        <button class="btn u-mg-t-2 shadow"
        type="submit"
        data-color="pink_active"
        data-block="true"
        @click.prevent="handleSubmit"
        :disabled="!isSubmittable"
        >占いの結果を見る</button>
      </div>

    </div>

  </div>
</div>
</div>

</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import StoryTrialInput from '@/utvStore/components/Trial/StoryTrialInput'
import { FORM_DATA } from '@/CONSTS'
import fetchAccountData from '@/utils/fetchAccountData'
import GuestTemporaryInput from '@/utils/GuestTemporaryInput'

export default {
  name: 'story-trial',
  components: {
    StoryTrialInput
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      displayNickname: '', // 結果表示用のニックネーム
      self: FORM_DATA.self,
      target: FORM_DATA.target,
      loadingData: false,
      isSubmittable: false,
      isShow: false
    }
  },
  props: {
    itemsId: { type: String, required: true },
    itemName: { type: String, required: true },
    inputParam: { type: Object, required: true },
    isFree: { type: Boolean, default: true },
    url: { type: String, default: '' }
  },
  beforeMount() {
    // 必要パラメータのみ表示
    let requiredFields = Object.keys(this.inputParam)
    Object.keys(this.self).forEach(key => {
      if (requiredFields.indexOf(key) === -1) {
        this.$delete(this.self, key)
      }
    })
    Object.keys(this.target).forEach(key => {
      if (requiredFields.indexOf(key) === -1) {
        this.$delete(this.target, key)
      }
    })

    if (this.isLoggedIn) {
      // ログイン済みの場合はuser/infoからユーザーデータを取得する
      let inputs = [this.self, this.target]
      fetchAccountData.getProfile(this.accessToken).then(res => {
        inputs.forEach(input => {
          for (let key in input) {
            if (key.includes('birthtime')) {
              let unknownColumnName = input[key].unknownName
              input[key].value = {
                value: res[key],
                unknown: res[unknownColumnName] === null ? 1 : Number(res[unknownColumnName])
              }
            } else {
              input[key].value = res[key]
            }
          }
        })
        this.$nextTick(function () {
          this.loadingData = true
        })
      })
    } else {
      // 未ログインの場合はsessionStorageから情報取得
      let inputs = [this.self, this.target]
      const tmpData = GuestTemporaryInput.data
      inputs.forEach(input => {
        for (let key in input) {
          if (key in tmpData) {
            if (key.includes('birthtime')) {
              Object.assign(input[key].value, tmpData[key])

            } else if(key.includes('birthday')){
              input[key].value = tmpData[key].length == 8 ? tmpData[key] : ''

            } else {
              input[key].value = tmpData[key]
            }
          }
        }
      })
    }
  },
  mounted() {
    this.$store.dispatch(type.RESET_TRIAL_RESULT)
    this.isSubmittable = this.checkSubmittable()
  },
  computed: {
    ...mapState({
      results: state => state.trial.result,
      accessToken: state => state.auth.accessToken
    }),
    ...mapGetters(['hasTrialResult', 'isLoggedIn']),
    shareUrl() {
      return {
        line() {
          return `http://line.me/R/msg/text/?${this.snsShareLine}`
        },
        twitter() {
          return `http://twitter.com/share?url=${this.url}`
        },
        facebook() {
          return `http://www.facebook.com/share.php?u=${this.url}`
        }
      }
    }
  },
  methods: {
    showInputArea(){
      this.isShow = this.isShow ? false : true
    },
    checkSubmittable() {
      var checkCount = 0
      Object.keys(this.self).forEach(key => {
        if(this.self[key].rules.required){
          checkCount += this.self[key].value != '' ? 0 : 1
        }else {
          checkCount += 0
        }
      })
      checkCount += this.errors.items.length
      return checkCount <= 0 ? true : false
    },

    // Google Analyticsに無料お試し占い利用のイベントを送信
    sendEvent() {
      window.gtag('event', 'PlayText', {
        custom_map: { dimension3: 'cpno' },
        cpno: window.Laravel.cpno
      })
    },

    // 入力トリガーのイベント
    updateInput(key, field) {
      this.isSubmittable = this.checkSubmittable()
      // sessionStorageへ値を保存する
      const value = field.value
      if (GuestTemporaryInput.data) {
        let data = Object.assign({}, GuestTemporaryInput.data)
        Object.assign(data, { [key]: value })
        GuestTemporaryInput.data = data
      }
    },

    // 占うボタン押下時のイベント処理
    handleSubmit() {
      this.adEbisScript();
      this.isShow = false;
      this.sendEvent()
      //On button pressed run validation
      this.$validator.validateAll().then(result => {
        if (result === false) {
          const errors = this.$validator.errors.items
          const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`)
          $('html, body').animate(
            {
              scrollTop: $errorsElm[0] ? $errorsElm.offset().top - 80 : 0
            },
            300
          )
        } else {
          this.getTrialResult()
        }
      })
    },

    adEbisScript(){
      window.ebis=window.ebis||[];
      ebis.push({
        argument: 'C2nEv6XN',
        page_id: 'buttonclick',
        member_name: '',
        amount: '',
        other1: '',
        other2: '',
        other3: '',
        other4: '',
        other5: '',
      });
    },

    // APIに送信するPOSTデータの整形を行う
    createPostData() {
      const data = {}
      $(this.$refs.form)
        .serializeArray()
        .forEach(item => {
          Object.assign(data, { [item.name]: item.value })
        })
      Object.assign(data, { items_id: this.itemsId })
      return data
    },

    // 無料占いの結果を取得する
    getTrialResult() {
      const data = this.createPostData()
      this.isLoading = true
      this.$store.dispatch(type.RESET_TRIAL_RESULT)
      this.$store
        .dispatch(type.GET_TRIAL_RESULT, data)
        .then(this.renderTrialResult)
        .catch(this.onTrialError)
        .finally(() => {
          this.isLoading = false
        })
        /*
        $("meta[property='og:url']").attr('content', results.ogp_url)
        $("meta[property='twitter:url']").attr('content', results.ogp_url)
        $("meta[property='og:image']").attr('content', results.ogp_img)
        $("meta[property='twitter:image']").attr('content', results.ogp_img)
        */
    },

    // 無料占いの非同期結果取得成功時に行う描画処理
    renderTrialResult() {
      this.displayNickname = this.self.nickname.value
      this.errorMessage = false
      // 結果表示エリアまでスクロールする
      const $resultArea = $(this.$refs.resultArea)
      $('html, body').animate(
        {
          scrollTop: $resultArea.offset().top - 80
        },
        300
      )
    },

    // 無料占いの非同期結果取得失敗時に行う描画処理
    onTrialError(error) {
      if (error) {
        this.errorMessage = error.message
      }
    }
  }
}</script>

<style lang="scss">
.formLabel {
  .labelBadge--required {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/StoryTrial.vue